<template>
  <div class="msg">跳转中...</div>
</template>
<script>
export default {
  name: "wxAuth",
  mounted() {
    /**
     * 改成在main.js直接拦截，不再到此页面跳转
     */

    let url = this.$route.query.callbackUrl || "";
    let code = this.$route.query.code || "";
    let and = "&";
    if (url) {
      url = decodeURIComponent(url);
      and = url.includes("?") ? "&" : "?";
      url = `${url}${and}code=${code}`;
      location.href = url;
    } else {
      location.href = location.origin;
    }
  },
};
</script>
<style lang="less" scoped>
.msg {
  text-align: center;
  font-size: 15px;
  color: #333;
  padding: 15px;
}
</style>
